// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hNzXg","title":"styles_title__KyPd0","item":"styles_item__j12lE","text":"styles_text__xfmj9","line":"styles_line__mjF+E","active":"styles_active__W73Wy"};